export const Type1 = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 6V26" stroke="currentColor" stroke-width="2"/>
<path d="M6 10V7C6 6.44772 6.44772 6 7 6H25C25.5523 6 26 6.44772 26 7V10" stroke="currentColor" stroke-width="2"/>
<path d="M11 26H21" stroke="currentColor" stroke-width="2"/>
</svg>`;
